import { mount } from 'svelte';
import App from './App.svelte';
import './app.css';
import { click } from './game/Sfx';

// Spell slots and unit frames sit inside `data-quiet`: casting and targeting sound for themselves.
window.addEventListener('click', (e) => {
  const control =
    e.target instanceof Element &&
    e.target.closest(
      'button, select, a[href], summary, input[type=checkbox], input[type=radio]',
    );
  if (control && !control.closest('[data-quiet]')) click();
});

// A mouse-clicked control lets go of focus, so game keys can't press or nudge it, and the browser
// never draws its keyboard focus ring on it. Keyboard clicks (detail 0) keep focus where the user put it.
window.addEventListener('click', (e) => {
  const focused = document.activeElement;
  if (e.detail === 0 || !(focused instanceof HTMLElement)) return;
  if (
    focused.matches(
      'button, summary, input[type=checkbox], input[type=radio], input[type=range]',
    )
  )
    focused.blur();
});

fetch('/api/config')
  .then((r) => r.json())
  .then(async ({ sentry }) => {
    if (sentry) (await import('./lib/sentry')).startSentry(sentry);
  })
  .catch(() => {});
mount(App, { target: document.getElementById('app')! });
